import React, { Fragment, useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";

import {
  InputCopy,
  FormGroup,
  Pill,
  Breadcrumbs,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Table,
  Input,
  ContentBlock,
  RadioGroup,
  ModalAlert,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import PAh2 from '../PAh2';




import {
  PAconnectorGTM,
  PAconnectorGA,
  PAconnectorFB,
  PAconnectorPN,
  PAconnectorTW
} from "../PAconnectors";

import merge from "deepmerge";
import { IntlProvider } from "react-intl";
import PAContentBlock from "../PAContentBlock";
import { Link } from "react-router-dom";
import { CardTodo, CardSite } from "../PAcardNew";

import {
  // PAchart1,
  PAchart2
  // PAchartMap
} from "../PAchart2";



function PAsbSettings() {

  return (<Fragment>
<FormGroup indentation="lg">

  <ContentBlock>


    <PAh2 title="General settings"></PAh2>


    <PAContentBlock title="Domain" border="lg">
      <FormGroup label="Xsolla domain" tooltip="This domain is set by default">
        <Input disabled={true} input={{
          // name: 'with-icon',
          value: "https://xsolla-store-demo-new-items.xsollasitebuilder.com"
        }} offset="right" extra={<Icon name="edit" hoverable={true} />} />
      </FormGroup>

      <FormGroup>
        <Switch name="switch_1" label="Use my own domain" tooltip="Tooltip to delete" input={{
          value: false
          // onChange: e => {
          //     setState({
          //       sandbox: !state.sandbox
          //     })
          // }
        }} />
      </FormGroup>


    </PAContentBlock>

    <PAContentBlock title="Development" border="lg">
      <div className="ui-form__section__content">
        <div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
          <div className="xsui-form-group__entry">
            <button data-id="sb_gotosb" ev="configuration" exv="[object Object]" className="xsui-button xsui-button--appearance-secondary xsui-button--size-sm" type="button">
              Go to Builder
            </button>
          </div>
        </div>
        <div className="landing-settings__share-controls__header">
          <div className="landing-settings__share-controls__header__title">
            Share via secret link
          </div>
          <div className="landing-settings__share-controls__header__control">
            <button className="xsui-button xsui-button--appearance-flatten xsui-button--size-md" type="button">
              Copy
            </button>
          </div>
          <div className="landing-settings__share-controls__header__control">
            <button className="xsui-button xsui-button--appearance-flatten xsui-button--size-md" type="button">
              Open link
            </button>
          </div>
        </div>
        <div style={{ display: "block" }}>
          <div style={{
            position: "relative",
            width: "100%",
            display: "block"
          }}>
            <input name="preview" disabled className="xsui-input xsui-input--size-md xsui-input--appearance-primary" type="text" data-id="preview" data-value="https://sitebuilder.xsolla.com/preview/xsolla-store-demo-new-items" defaultValue="https://sitebuilder.xsolla.com/preview/xsolla-store-demo-new-items"/>
          </div>
        </div>
        <div className="landing-settings-development">
          <div className="landing-settings-development__desc">
            Last changed: m.miroshnikov @xsolla.com 05/15/19, 3: 49 PM
          </div>
          <div className="landing-settings-development__desc">
            Last published: m.miroshnikov @xsolla.com 05/15/19, 3: 49 PM
          </div>
        </div>
        <button data-id="sb_republish" className="xsui-button xsui-button--appearance-outline-secondary xsui-button--size-sm" type="button">
          Republish now
        </button>
      </div>
    </PAContentBlock>


    <PAContentBlock title="Actions" border={false}>
      <FormGroup indentation="sm">
        <Link to="/game_keys" aria-current="true" href="#">
          <Button appearance="flatten" style={{ color: "#747e8a" }}>
            <Icon name="dublicate"/>
            &nbsp; Duplicate Site
          </Button>
        </Link>
      </FormGroup>

      <FormGroup indentation="sm">
        <Link to="/game_keys" aria-current="true" href="#">
          <Button appearance="flatten" style={{ color: "#747e8a" }}>
            <Icon name="delete"/>
            &nbsp; Delete Site
          </Button>
        </Link>
      </FormGroup>
    </PAContentBlock>

  </ContentBlock>

</FormGroup>
<FormGroup indentation="lg">

  <ContentBlock>


    <PAh2 title="Apps & connectors"></PAh2>

    <PAContentBlock title="" border={false}>
      <div style={{
        display: "grid",
        // gridTemplateColumns: "repeat(2, 1fr)",
        gridTemplateColumns: "repeat(2, 48%)",
        // gridTemplateRows: '200px',
        gridColumnGap: "4%",
        gridRowGap: "16px"
        // width: "100%"
      }}>
        <PAconnectorGA>
          Tasks and reports website traffic
        </PAconnectorGA>

        <PAconnectorFB>
          Add the Facebook pixel to your website to measure the
          impact of your ads.
        </PAconnectorFB>

        <PAconnectorPN>
          <span>
            Create and manage influencer programs and affiliate
                      campaigns.{" "}
            <a href="https://developers.xsolla.com/doc/partner_network/" target="_blank">
              Learn more
            </a>
          </span>
        </PAconnectorPN>

        <PAconnectorGTM>
            aScript and HTML tags used to track your site's
          traffic.
        </PAconnectorGTM>

        <PAconnectorTW>
          Track the actions users take after viewing or engaging
          with your ads on Twitter.
        </PAconnectorTW>
      </div>
    </PAContentBlock>

  </ContentBlock>
</FormGroup>
</Fragment>)};


export default PAsbSettings;